/** 备课数据相关 */
import {D_URL, C_URL, get, post, postByJson, URL_ARRAY} from './https.js'
import {download, STATISTICS_URL} from './https'

// 通过zip文件导入教学设计url
const IMPORT_TD_URL = D_URL + 'd0001/importTd'
// 文件上传url
const UPLOAD_FILE_URL = D_URL + 'd0001/upload'

export default {
    UPLOAD_FILE_URL,
    IMPORT_TD_URL,
    URL_ARRAY,

    /** 教学设计部分 */
    // 分页查询我的教学设计
    pagingUserTd(param) {
        return get(D_URL + 'd0001/paging/user/td', param)
    },
    listUserTd(param) {
        return get(D_URL + 'd0001/list/user/td/kp', param)
    },
    // 添加教学设计
    addTd(param) {
        return postByJson(D_URL + 'd0001/add', param)
    },
    // 删除教学设计
    deleteTd(param) {
        return post(D_URL + 'd0001/delete', param)
    },
    // 查询教学设计信息
    getTdInfo(param) {
        return get(D_URL + 'd0001/info', param)
    },
    // 复制讲义
    copyTd(param) {
        return get(D_URL + 'd0001/copy', param)
    },
    // 获取PPT的属性信息
    getPptProp(param) {
        return get(D_URL + 'd0001/get/ppt/prop', param)
    },
    // 根据课程ID查询相关联的备课
    getTdListByCourseId(param) {
        return get(D_URL + 'd0001/list/by/courseId', param)
    },
    // 保存讲义
    savePPT(param) {
        return postByJson(D_URL + 'd0001/save/ppt', param)
    },
    // 保存讲义
    saveAsAllTd(param) {
        return postByJson(D_URL + 'd0001/saveAs/ppt', param)
    },
    // 查询讲义
    infoPPT(param) {
        return get(D_URL + 'd0001/info/ppt', param)
    },
    // pagingPptBgImg: 分页查询ppt的图片背景（暂无任何参数）
    pagingPptBgImg(param) {
        return get(D_URL + 'd0001/paging/ppt/bg/img', param)
    },
    // 查看教学环节列表
    listMTdStep(param) {
        return get(D_URL + 'd0001/list/mTdStep', param)
    },
    // 共享教学设计
    shareTd(param) {
        return postByJson(D_URL + 'd0001/share', param)
    },
    // 共享教学设计
    shareAllTd(param) {
        return postByJson(D_URL + 'd0001/shareAll', param)
    },
    // 查询共享部门和用户列表
    listDeptAndShareUser(param) {
        return get(D_URL + 'd0001/list/share/user', param)
    },
    // 查询学校共享部门和用户列表
    listSchoolAndDeptAndShareUser(param) {
        return get(D_URL + 'd0001/list/share/userBySchool', param)
    },
    // 查询学校共享部门和用户列表
    listSchoolAndDeptAndShareAllUser() {
        return get(D_URL + 'd0001/list/shareAll/userBySchool',)
    },
    // 查询共享部门和用户列表
    listDeptAndShareUserKhzy(param) {
        return get(D_URL + 'd0002/list/share/user', param)
    },
    // 查询学校共享部门和用户列表
    listSchoolAndDeptAndShareUserKhzy(param) {
        return get(D_URL + 'd0002/list/share/userBySchool', param)
    },
    // 导出教学设计
    exportTd(param) {
        return get(D_URL + 'd0001/exportTd', param)
    },
    // 导出教学设计(压缩成zip文件)
    exportTdToZip(param) {
        return post(D_URL + 'd0001/exportTdToZip', param)
    },

    /** 课后作业部分 */
    // 新增课后作业
    addKhzy(param) {
        return postByJson(D_URL + 'd0002/add', param)
    },
    saveAsKhzy(param) {
        return postByJson(D_URL + 'd0002/saveAs', param)
    },
    // 查询课后作业列表
    pagingKhzy(param) {
        return get(D_URL + 'd0002/paging', param)
    },
    // 查询共享课后作业列表
    pagingShareKhzy(param) {
        return get(D_URL + 'd0002/share/paging', param)
    },
    // 根据id查询课后作业的详细信息
    getKhzyInfoById(param) {
        return get(D_URL + 'd0002/info', param)
    },
    // 根据id查询课后作业附件的详细信息
    getKhzyTaskInfoById(param) {
        return get(D_URL + 'd0002/taskInfo', param)
    },
    // 根据id查询课后作业的详细信息
    addKhzyExer(param) {
        return postByJson(D_URL + 'd0002/add/exer', param)
    },
    // 发送课后作业
    sendKhzy(param) {
        return postByJson(D_URL + 'd0002/send', param)
    },
    sendClassInfoList(param) {
        return postByJson(D_URL + 'd0002/sendClassInfoList', param)
    },
    //复制课后作业
    copyKhzy(param) {
        return postByJson(D_URL + 'd0002/copy', param)
    },
    //复制课后作业
    shareKhzy(param) {
        return postByJson(D_URL + 'd0002/shareKhzy', param)
    },
    // 根据id添加附件信息
    addKhzyTask(param) {
        return postByJson(D_URL + 'd0002/add/task', param)
    },
    /** 课后作业报告部分 */
    // 课后作业列表查询
    pagingKhzyBg(param) {
        return get(D_URL + 'd0003/paging', param)
    },
    // 查询作业下的作业报告
    pagingKhzyIdBg(param) {
        return get(D_URL + 'd0003/khzy/paging', param)
    },
    // 删除课后作业报告
    deleteKhzyBg(param) {
        return post(D_URL + 'd0003/delete', param)
    },
    // 课后作业发送历史记录想关联的课后作业详细信息
    infoKhzyBg(param) {
        return get(D_URL + 'd0003/info', param)
    },
    // 导出成绩
    exportClassScore(param) {
        return download(D_URL + 'd0003/exportClassScore', param)
    },
    // 导出成绩
    exportClassScoreExam(param) {
        return download(D_URL + 'd0003/exportClassScoreExam', param)
    },
    // 取得课后作业发送记录关联的班级
    getKhzyFsCls(param) {
        return get(D_URL + 'd0003/fs/class', param)
    },
    // 取得课后作业学生列表
    listKhzyFsStudent(param) {
        return get(D_URL + 'd0003/list/student', param)
    },
    // 查询课后作业每道试题的平均分
    listEachExerAvgScore(param) {
        return get(D_URL + 'd0003/list/each/exer/avg/score', param)
    },
    // 查询课后作业每道试题的得分率
    listEachExerScoreRate(param) {
        return get(D_URL + 'd0003/list/each/exer/score/rate', param)
    },
    // 查询班级作业知识点得分率
    listEachKpScoreRate(param) {
        return get(D_URL + 'd0003/list/each/kp/score/rate', param)
    },
    // 试题数量
    listKhzyExer(param) {
        return get(D_URL + 'd0003/list/exercise/num', param)
    },
    // 试题类型
    listKhzyExerType(param) {
        return get(D_URL + 'd0003/list/exercise/type', param)
    },
    // 试题类型(学生分析)
    listStudentFsExerType(param) {
        return get(D_URL + 'd0003/list/exercise/StudentType', param)
    },
    // 学生答案
    listKhzyStuAnswer(param) {
        return get(D_URL + 'd0003/list/student/answer', param)
    },
    // 课后作业试题，每个选项，每个空学生作答情况，人数，姓名
    listAnswerItemStuNum(param) {
        return get(D_URL + 'd0003/list/answer/item/num', param)
    },
    // 查询全班的平均分 (已提交)
    getClsAverageScore(param) {
        return get(D_URL + 'd0003/cls/averageSubmit/score', param)
    },
    // 查询全班的平均答题用时 (已提交)
    getClsAverageUseTime(param) {
        return get(D_URL + 'd0003/cls/averageSubmit/useTime', param)
    },
    // 查询全班的平均分
    getAverageScore(param) {
        return get(D_URL + 'd0003/cls/average/score', param)
    },
    // 查询全班的最高分
    getClsHighestScore(param) {
        return get(D_URL + 'd0003/cls/highest/score', param)
    },
    // 查询授课页发送习题信息
    getGlKhzyInfoById(param) {
        return get(D_URL + 'd0003/gl/fs/exer/info', param)
    },
    // 查询授课页学生一道题的作答
    getStuAnswerOfExer(param) {
        return get(D_URL + 'd0003/gl/fs/exer/stu/answer', param)
    },
    // 查询授课页学生一道题的作答
    getElemAnslysisOfTest(param) {
        return post(D_URL + 'd0003/gl/fs/exer/elem/analysis', param)
    },

    /** 教学目标设计 **/
    //获取教学目标设计
    getAllTargetList(param) {
        return get(D_URL + 'd0001/mTdGoalInfo', param)
    },
    // 校验我的教学设计命名是否重复
    selectTeachingDesignByName(param) {
        return postByJson(D_URL + 'd0001/selectTeachingDesignByName', param)
    },
    // 添加教学设计
    addTarget(param) {
        return postByJson(D_URL + 'd0001/addTarget', param)
    },
    // 保存教学设计
    saveTarget(param) {
        return postByJson(D_URL + 'd0001/saveTarget', param)
    },
    /**判断知识点进入教学设计进入方式**/
    selectTargetByPoint(param) {
        return postByJson(D_URL + 'd0001/selectTargetByPoint', param)
    },
    /**根据教学设计id查询相关选中知识点 **/
    initSelectPoint(param) {
        return get(D_URL + 'd0001/initSelectPoint', param)
    },
    /**添加老师选中的该教学设计的知识点 **/
    addKnowledgePoint(param) {
        return postByJson(D_URL + 'd0001/addKnowledgePoint', param)
    },
    /** 删除不在catalogueIdList中的教学设计每页与教材目录关联表 **/
    deletePageCatalogue(param) {
        return postByJson(D_URL + 'd0001/deletePageCatalogue', param)
    },
    /** 根据教学设计id查询先关教学目标**/
    initSelectGoal(param) {
        return get(D_URL + 'd0001/initSelectGoal', param)
    },
    //刪除教学设计讲义页关联的习题
    delTeachingDesignExer(param) {
        return get(D_URL + 'd0001/delTeachingDesignExer', param)
    },
    //删除教学设计讲义页关联的习题(按题型)
    delTeachingDesignExerByType(param) {
        return get(D_URL + 'd0001/delTeachingDesignExerByType', param)
    },
    //根据知识点，复制教学环节相关信息
    copyTdStepByCatalogue(param) {
        return postByJson(D_URL + 'd0001/copyTdStepByCatalogue', param)
    },
    /** 教学目标设计 **/
    //下载教学目标设计
    downloadLessonPlans(param) {
        return get(D_URL + 'd0001/downloadLessonPlans/', param)
    },
    // 获取教学目标
    getGoal(param) {
        return get(D_URL + 'd0001/getGoal', param)
    },
    // 导出显示配置
    getRTdExportConfig(param) {
        return get(D_URL + 'd0001/getRTdExportConfig', param)
    },
    // 获取教学过程
    getStepInfo(param) {
        return get(D_URL + 'd0001/getStepInfo', param)
    },
    //插入背景图片
    addBackGroundImg(param) {
        return postByJson(D_URL + 'd0001/addBackGroundImg', param)
    },
    //插入base64图片
    pasteImage(param) {
        return post(D_URL + 'd0001/pasteImage', param)
    },
    //删除背景图片
    delBackGroundImg(param) {
        return post(D_URL + 'd0001/delBackGroundImg', param)
    },
    //复制教案
    copyTeachingDesign(param) {
        return get(D_URL + 'd0001/copyTeachingDesign', param)
    },
    //获取登录用户
    getLoginUser(param) {
        return get(D_URL + 'd0001/getLoginUser', param)
    },
    //查找当前用户所创建的课程
    getClasses() {
        return get(D_URL + 'd0001/getClasses')
    },
    // 查询该课程下课前预习
    getBeforeClassTaskByCourseId(param) {
        return post(D_URL + 'd0002/getBeforeClassTaskByCourseId', param)
    },
    // 查询该课程下课后作业
    getAfterClassTaskByCourseId(param) {
        return post(D_URL + 'd0002/getAfterClassTaskByCourseId', param)
    },
    // 记录备课开始时间
    recordLessonPreparation() {
        return get(D_URL + 'd0001/recordLessonPreparation')
    },
    // 记录备课结束时间
    recordLessonPreparationEnd(param) {
        return get(D_URL + 'd0001/recordLessonPreparationEnd', param)
    },
    getMKnowledgePoint(param) {
        return post(D_URL + 'd0001/getMKnowledgePoint', param)
    },
    getFlowId(param) {
        return get(D_URL + 'd0001/getFlowId', param)
    },
    // 检查资源是否可以播放
    checkResFree(param) {
        return get(D_URL + 'd0001/checkResFree', param)
    },
    // 获取会计分录总账科目
    getTAccountLedgerTemplate(param) {
        return get(D_URL + 'd0001/getTAccountLedgerTemplate', param)
    },
    // 查询作业名字
    selectHomeWorkName(param) {
        return get(D_URL + 'd0002/selectHomeWorkName?id=' + param.id)
    },
    // 查询作业名字
    selectHomeWork(param) {
        return get(D_URL + 'd0002/selectHomeWork?id=' + param.id)
    },
    // 更新作业名字
    updateHomeWorkName(param) {
        return post(D_URL + 'd0002/updateHomeWorkName', param)
    },
    // 查询作业名字
    selectHomeWorkSetting(param) {
        return get(D_URL + 'd0002/selectHomeWorkSetting?id=' + param.id)
    },
    // 更新作业设置
    updateHomeWorkSetting(param) {
        return post(D_URL + 'd0002/updateHomeWorkSetting', param)
    },
    // 删除作业
    delTask(param) {
        return get(D_URL + 'd0002/delTask', param)
    },
    // 复制作业
    copyTask(param) {
        return get(D_URL + 'd0002/copyTask', param)
    },
    checkResourceByCourseId(param) {
        return post(D_URL + 'd0001/checkResourceByCourseId', param)
    },
    getNewTaskId(param) {
        return post(D_URL + 'd0001/getNewTaskId', param)
    },
    copyExer(param) {
        return postByJson(D_URL + 'd0001/copyExer', param)
    },
    //删除作业试题
    delKhzyExer(param) {
        return get(C_URL + 'c0002/del/khzyExer', param)
    },
    //"/del/exercise"

    delGroup(param) {
        return get(C_URL + 'c0002/del/group', param)
    },

    //删除作业试题
    delPaperExer(param) {
        return get(C_URL + 'c0002/del/paperExer', param)
    },
    // 获取习题
    getExerArrByIds(param) {
        return postByJson(D_URL + 'd0001/getExerArrByIds', param)
    },

    getTestQuestionStatistics (param){
        return get(C_URL + 'c0002/getTestQuestionStatistics', param)
    }

}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-d.js